// extracted by mini-css-extract-plugin
export var checkbox = "_8q-0";
export var circle = "_8q-3";
export var horizontalContainer = "_8q-7";
export var sm = "_8q-5";
export var switch0 = "_8q-2";
export var switchDisabled = "_8q-8";
export var switchEnabled = "_8q-1";
export var textSwitchContainer = "_8q-9";
export var textSwitchOption = "_8q-a";
export var textSwitchOptionSelected = "_8q-b";
export var verticalContainer = "_8q-6";
export var xs = "_8q-4";